<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  departmentComputed,
  authComputed,
  departmentListMethod,
  collegeListMethod,
  collegeComputed,
  siteListMethod,
} from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      collegelist: [],
      collegeId: null,
      deptError: null,
      deptSuccess: null,
      deptDataStatus: false,
      isDeptError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      siteconfiglist: [],
    }
  },
  computed: {
    ...departmentComputed,
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.currentUser.user.platform_id
    }
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
    } else if (this.role === 'administrator') {
      this.getColleges()
    }
  },
  methods: {
    ...departmentListMethod,
    ...collegeListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    // save department method
    updateDepartmentData() {
      this.isLoading = true
      const Data = {
        id: this.data._id,
        name: this.name,
        college_id: this.collegeId,
        platform_id: this.platformId,
      }
      this.updateDepartment({ Data })
        .then((resp) => {
          this.isLoading = false
          this.deptSuccess = 'Department Updated Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.deptError = getError.message
          this.isDeptError = true
        })
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32 ||
          event.charCode === 38
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    getData() {
      this.name = this.data.name
      this.college_id = this.data.college_id
    },

    getColleges() {
      this.collegeId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    resetModal() {
      this.isDeptError = false
      this.name = this.data.name
      this.classCode = this.data.classCode
      this.departmentId = this.data.department_id
      this.collegeId = this.data.college_id
      this.platformId = this.data.platform_id
    },
  },
}
</script>

<template>
  <b-modal
    id="department-update-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isDeptError"
          variant="danger"
          v-html="deptError"
        ></b-alert>
        <b-alert
          v-model="isdeptSuccess"
          variant="success"
          v-html="deptSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateDepartmentData">
          <b-form-group
            v-if="role === 'admin'"
            label="Select Platform"
            label-for="input-1"
          >
            <b-form-select
              v-model="platformId"
              :options="siteconfiglist"
              @change="getColleges"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role === 'administrator' || role === 'admin'"
            label="Select College"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeId"
              :options="collegelist"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Department Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              placeholder="Enter Department Name"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
